import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { WebSocketService } from './services/web-socket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  showLogoutButton: boolean = true;
  showSearchButton: boolean = true;
  showDownloadButton: boolean = true;
  showNavbar: boolean = true;
  showAppSwitcher: boolean = false;
  currentApp: 'picture-search' | 'data-sync' | null = null;

  constructor(
    private router: Router,
    private webSocketService: WebSocketService,
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check the current route and set showNavbar accordingly
        const isPublic = this.router.url.includes('/public');
        const isAppSelector = this.router.url.includes('/app-selector');
        const isDashboard = this.router.url.includes('/dashboard');
        const isDataSync = this.router.url.includes('/data-sync');
        const isDownloadCenter = this.router.url.includes('/download-center');

        this.showLogoutButton = !isPublic;
        this.showDownloadButton =
          !isPublic && !isDownloadCenter && (isDashboard || isDataSync);
        this.showSearchButton = !isPublic && isDownloadCenter;
        this.showNavbar = !isPublic;
        this.showAppSwitcher =
          !isPublic &&
          !isAppSelector &&
          (isDashboard || isDataSync || isDownloadCenter);

        if (isDashboard) {
          this.currentApp = 'picture-search';
        } else if (isDataSync) {
          this.currentApp = 'data-sync';
        } else {
          this.currentApp = null;
        }
      }
    });
  }
  navigateToDownloadCenter() {
    this.router.navigate(['/']).then(() => {
      // Navigate back to the desired route (e.g., '/download-center')
      this.router.navigateByUrl('/download-center');
    });
  }

  navigateToSearchSide() {
    // Navigate based on current app
    if (this.currentApp === 'data-sync') {
      this.router.navigate(['/secure/data-sync']);
    } else {
      this.router.navigate(['/']).then(() => {
        this.router.navigate(['/dashboard']);
      });
    }
  }

  navigateToAppSelector() {
    this.router.navigate(['/secure/app-selector']);
  }

  getCurrentAppName(): string {
    if (this.currentApp === 'picture-search') {
      return 'Picture Search';
    } else if (this.currentApp === 'data-sync') {
      return 'Data Sync';
    }
    return '';
  }

  onLogoutButtonClick() {
    this.webSocketService.disconnect();
    localStorage.clear();
    this.router.navigateByUrl('/public/logout');
  }

  title = 'PictureToCloud-Base-Frontend';
}
